import { Injectable } from "@angular/core";
import { HttpClient } from "@angular/common/http";
import { DataService } from "../components/shared/services/data.service";
import { HistoricoGeral, PesquisaHistoricoEmail } from "../models/historico-geral.model";
import { Empresa } from "../models/empresa.model";
import { Observable } from "rxjs";
import { EmailLog } from "../models/emailLog.model";

@Injectable()
export class HistoricoGeralService extends DataService {

  url = this.urlApi + 'v1/historico/';

  constructor(private http: HttpClient) {
    super();
  }
  getHistoricoProposta(idEmpresa: string): Observable<Array<HistoricoGeral<string>>> {
    return this.http.post<HistoricoGeral<Empresa>[]>(this.url + 'proposta/' + idEmpresa, {})
      .catch(this.handleError);
  }

  getHistoricoEmail(pesquisa: PesquisaHistoricoEmail): Observable<Array<any>> {
    return this.http.post<Array<EmailLog>>(this.url + 'email/filtro', pesquisa)
      .catch(this.handleError);
  }
}



// WEBPACK FOOTER //
// ./src/app/services/historico-geral.service.ts